import React from 'react';

import styles from './LegalFooter.module.scss';

const { 'legal-footer': legalFooterClass } = styles;

const LegalFooter = () => {
  return (
    <div className={legalFooterClass}>
      <span>©2020 All Rights Reserved. Everdays® is a registered trademark.</span>
      <div className="footer-links">
        <a target="_blank" href="/privacy">
          Privacy Policy
        </a>{' '}
        -{' '}
        <a target="_blank" href="/terms">
          Terms of Service
        </a>
      </div>
    </div>
  );
};

export default LegalFooter;
